var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wrong",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.67 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a53089ed-97d1-40fd-a49b-35905b75e946,.a8aea2fa-8d81-479d-aa84-f4fbecfa2dc2{fill:#47568c;}.b4b2c830-308e-42f4-824e-4f2a3eb4cff8{fill:#29376d;}.bfe46103-6c00-4f85-8390-224be17df389{fill:#e13522;}.bb604312-1b52-498c-8531-a59a7e278df1{fill:#e84937;}.bcffdf7b-3ee2-4102-89e9-aaa960ac4b7d{fill:#edf5ff;}.b60113aa-7a2a-45a3-ba5e-f0201896d9ee{fill:#d5e8fe;}.a030ec65-7db3-4d96-821e-79de58198ef9{fill:#b28b67;}.fd1255ae-473f-40c5-8dce-eee01021e67d{fill:#ffc539;}.a8aea2fa-8d81-479d-aa84-f4fbecfa2dc2{fill-opacity:0.8;}.a8b087d8-23c9-48b5-a72d-c903f0e08363{fill:none;stroke:#815832;stroke-opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fcf8c34d-022d-4c5b-bc4b-4b146d9c6023",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e849f6e8-1a0e-4ae2-83df-e98968ee3585",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a53089ed-97d1-40fd-a49b-35905b75e946",
    d: "M59.77,35.86h-9V54l-6,6v6H68.73V35.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b4b2c830-308e-42f4-824e-4f2a3eb4cff8",
    d: "M59.77,35.86h9V65.94h-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bfe46103-6c00-4f85-8390-224be17df389",
    d: "M59.77,47.81a23.91,23.91,0,1,0-23.91-23.9A23.9,23.9,0,0,0,59.77,47.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb604312-1b52-498c-8531-a59a7e278df1",
    d: "M83.67,23.91A23.93,23.93,0,0,0,59.77,0V47.81A23.93,23.93,0,0,0,83.67,23.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bcffdf7b-3ee2-4102-89e9-aaa960ac4b7d",
    d: "M64,23.91l6-6L65.74,13.7l-6,6-6-6-4.23,4.23,6,6-6,6,4.23,4.23,6-6,6,6L70,29.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b60113aa-7a2a-45a3-ba5e-f0201896d9ee",
    d: "M70,29.88l-6-6,6-6L65.74,13.7l-6,6v8.45l6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a030ec65-7db3-4d96-821e-79de58198ef9",
    d: "M68.73,60H50.8V54A15,15,0,0,0,36.16,65.94H17.93V96.75l6,5.25H68.73A15,15,0,0,0,83.67,87.06V74.91A15,15,0,0,0,68.73,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a030ec65-7db3-4d96-821e-79de58198ef9",
    d: "M83.67,87.06V74.91A15,15,0,0,0,68.73,60h-9v42h9A15,15,0,0,0,83.67,87.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fd1255ae-473f-40c5-8dce-eee01021e67d",
    d: "M23.91,92a10,10,0,0,1-10,10H0V60H13.91a10,10,0,0,1,10,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8aea2fa-8d81-479d-aa84-f4fbecfa2dc2",
    d: "M12,74.91a3,3,0,1,1,3,3A3,3,0,0,1,12,74.91Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a8b087d8-23c9-48b5-a72d-c903f0e08363",
    x1: 83,
    y1: 72.5,
    x2: 76,
    y2: 72.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a8b087d8-23c9-48b5-a72d-c903f0e08363",
    x1: 83,
    y1: 78.5,
    x2: 76,
    y2: 78.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a8b087d8-23c9-48b5-a72d-c903f0e08363",
    x1: 83,
    y1: 84.5,
    x2: 76,
    y2: 84.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a8b087d8-23c9-48b5-a72d-c903f0e08363",
    x1: 83,
    y1: 90.5,
    x2: 76,
    y2: 90.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.8898c3bbe964d479d5e3b52b24a73256.svg";
export { ForwardRef as ReactComponent };